import { applyAltStacking, getAltStackingWidth, getQT, scaleAllInfoBlocks, setVisible, } from "../utils/dom";
export const settingsCategories = [
    {
        title: "Appearance",
        options: [
            {
                id: "guiScale",
                name: "GUI Scale",
                description: "(scales the timer GUI)",
                type: "slider",
                min: 0.5,
                max: 2,
                step: 0.1,
                default: 1,
                valueFormat: (val) => `x${val}`,
                onChange: (val) => scaleAllInfoBlocks(val),
            },
            {
                id: "showGCTimer",
                name: "Show Golden Cookie timer",
                description: `(toggles Golden Cookie timer visibility)`,
                type: "boolean",
                default: true,
                onChange: (val) => setVisible(getQT("GCTimer"), val),
            },
            {
                id: "showBuffToggler",
                name: "Show buff toggler",
                description: `(toggles toggler visibility a.k.a "Hide buffs" button (meta toggler time))`,
                type: "boolean",
                default: true,
                onChange: (val) => setVisible(getQT("buffToggler"), val),
            },
            {
                id: "shortBuffNames",
                name: "Short buff names",
                description: "(shortens the buff names (e.g. Click Frenzy -> CF, Building specal -> BS))",
                type: "boolean",
                default: false,
            },
            {
                id: "showBuildingName",
                name: "Show building names",
                description: '(shows the building names on the "building special" buffs)',
                type: "boolean",
                default: false,
            },
            {
                id: "showMultipliers",
                name: "Show buff mult.",
                description: "(shows the buff multipliers)",
                type: "boolean",
                default: true,
            },
        ],
    },
    {
        title: "Highlighting",
        options: [
            {
                id: "highlightExistingBuffs",
                name: "Highlight existing buffs",
                description: "(highlights the buffs that you already have)",
                type: "boolean",
                default: true,
            },
            {
                id: "warnLastingBuffs",
                name: "Warn lasting buffs",
                description: "(warns you when you have a buff that will expire in less than 10 seconds)",
                type: "boolean",
                default: true,
                onChange: (val) => {
                    l("QTContainer")?.classList.toggle("qt_warnOff", !val);
                },
            },
        ],
    },
    {
        title: "Misc",
        options: [
            {
                id: "updateFrequency",
                name: "Update Frequency",
                description: "(changes how often the buff timers are updated, low tick values can cause minor lag)",
                type: "slider",
                min: 0,
                max: 100.1,
                step: 2,
                default: 10,
                valueFormat: (val) => val === 0 ? "every tick" : `every ${val} ticks`,
            },
            {
                id: "showOldBuffTImers",
                name: "Show old buff timers",
                description: "(shows the old buff timers, just if you wanna see them idk)",
                type: "boolean",
                default: true,
                onChange: (val) => {
                    setVisible(l("buffs"), val, "block");
                    if (settings.alternativeBuffStacking) {
                        const container = l("QTContainer");
                        if (container)
                            container.style.width = getAltStackingWidth();
                    }
                },
            },
            {
                id: "alternativeBuffStacking",
                name: "Alt. buffs stacking",
                description: "(toggles the buff stacking from vertical to horizontal)",
                type: "boolean",
                default: false,
                onChange: (val) => applyAltStacking(val),
            },
            {
                id: "formatLongTimers",
                name: "Format long timers",
                description: "(formats buffs longer than a minute as Xm Xs / Xh Xm Xs)",
                type: "boolean",
                default: false,
            },
            {
                id: "showTotalBuffMultiplier",
                name: "Show total buff multiplier",
                description: "(shows the combined multiplier of all active buffs)",
                type: "boolean",
                default: false,
                onChange: (val) => setVisible(getQT("totalMult"), val),
            },
        ],
    },
];
export const settings = {
    ...Object.fromEntries(settingsCategories.flatMap((category) => category.options.map((option) => [option.id, option.default]))),
    collapseSettings: false,
};
